import { ApplicationState } from '../../../../store/types';
import { PieChartAnalyticsData } from '../../../shared/analytics/PieChart';
import { getAnalyticsRoot } from '../../store/selectors';
import { AdminAnalyticsChart, AdminAttestationAnalytics } from './types';

export const getFetchingAnalytics = (state: ApplicationState): AdminAnalyticsChart[] => getAnalyticsRoot(state).fetchingAnalytics;

export const getAttestationProgressAnalytics = (state: ApplicationState): AdminAttestationAnalytics[] => getAnalyticsRoot(state).attestationProgress;

export const getClientPageUsageAnalytics = (state: ApplicationState): PieChartAnalyticsData[] => getAnalyticsRoot(state).pageUsageAnalytics;
